import { useEffect, useState } from "react";
import { useTheme } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DataGridTopHeader } from "../../../../components/styled";
import { getAllStudents } from "../../../../api/student";
import { studentTableColumns } from "../../../../data/mockTableColumns";
import DashboardLayout from "../../../../components/global/DashboardLayout";
import DashboardHeader from "../../../../components/global/DashboardHeader";

const Students = () => {
  const [students, setStudents] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const theme = useTheme();

  useEffect(() => {
    const fetchAllStudents = async () => {
      try {
        const allStudents = await getAllStudents();
        setStudents(allStudents);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchAllStudents();
  }, []);

  // Filtered students based on search query
  const filteredStudents = students.filter(
    (user) =>
      user.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <DashboardLayout>
      {/* HEADER */}
      <DashboardHeader
        title="Students"
        subtitle="List of All Students Profile"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      <DataGridTopHeader theme={theme}>
        <DataGrid
          rows={filteredStudents}
          columns={studentTableColumns}
          getRowId={(row) => row._id}
          checkboxSelection
          disableRowSelectionOnClick
          pageSizeOptions={[10, 20, 30]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          slots={{
            toolbar: GridToolbar,
          }}
        />
      </DataGridTopHeader>
    </DashboardLayout>
  );
};

export default Students;
